import { render, staticRenderFns } from "./Haggerston.vue?vue&type=template&id=545b0b8c&"
import script from "./Haggerston.vue?vue&type=script&lang=js&"
export * from "./Haggerston.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports